import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";

export interface IAppState {}

@Module({ dynamic: true, store, name: "app" })
class App extends VuexModule implements IAppState {
  public landMarkId: any = null;

  @Mutation
  private landMarkIdMu(params: any) {
    this.landMarkId = params;
  }

  @Action
  public landMarkIdAc(params: any) {
    this.landMarkIdMu(params);
  }
}

export const AppModule = getModule(App);
